
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export const Permission = ({permission,children})=>{
  const permissionData = useSelector((state)=>state.permission.permissions);

   if(permissionData.some(item=>item?.libelle.includes(permission))){
    return children;
   }else{
    return <Navigate to="/refused" />;
   }
}
